<template>
  <footer
    class="bg-#000 py-80px pb-40px lt-sm:py-48px lt-sm:pb-[calc(24px+env(safe-area-inset-bottom))] lt-sm:text-center text-white/78"
  >
    <div class="landing-container grid">
      <div
        class="gap-48px lt-sm:flex-col lt-sm:items-center lt-sm:gap-32px flex items-start justify-between"
      >
        <nav class="w-720px gap-72px lt-sm:hidden flex" aria-label="底部导航">
          <div>
            <h3 class="pf-sc-semibold mb-16px font-s-16px m-0 leading-[22px] text-white">产品</h3>
            <ul class="gap-14px m-0 flex list-none flex-col p-0">
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huiguanjia.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  绘管家物业云平台
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huifuwu.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  绘服务居民平台
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 class="pf-sc-semibold mb-16px font-s-16px m-0 leading-[22px] text-white">
              解决方案
            </h3>
            <ul class="gap-14px m-0 flex list-none flex-col p-0">
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/solutions/SFS-001"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  智慧收费系统
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/solutions/CTD-002"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  综合工单调度
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/solutions/MPI-003"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  移动巡检巡更
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/solutions/SPLM-004"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  智慧车场管理
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/solutions/DDC-005"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  数据决策中心
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 class="pf-sc-semibold mb-16px font-s-16px m-0 leading-[22px] text-white">
              关于我们
            </h3>
            <ul class="gap-14px m-0 flex list-none flex-col p-0">
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/about"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  公司简介
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/case-studies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  客户案例
                </a>
              </li>
              <li>
                <a
                  class="pf-sc-regular font-s-14px text-#9ca0a7 leading-[20px] transition-colors duration-300 hover:text-white"
                  href="https://www.huijiakeji.com/honor-qualification"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  荣誉资质
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <div class="gap-80px lt-sm:flex-col lt-sm:items-center lt-sm:gap-32px flex items-start">
          <div class="lt-sm:flex lt-sm:flex-col lt-sm:items-center">
            <h3
              class="pf-sc-semibold mb-16px font-s-16px lt-sm:font-s-26px lt-sm:leading-[40px] m-0 leading-[22px] text-white"
            >
              关注或联系我们
            </h3>
            <a
              class="pf-sc-regular mt-16px font-s-14px text-#94a3b8 lt-sm:font-s-22px block leading-[22px] transition-colors hover:text-white"
              href="tel:4006007709"
              aria-label="电话：400-600-7709"
            >
              <span class="lt-sm:hidden">电话：400-600-7709</span>
              <i
                class="i-custom-mobile-phone lt-sm:!inline-block lt-sm:h-58px lt-sm:w-552px hidden"
                aria-hidden="true"
              ></i>
            </a>
            <p
              class="pf-sc-regular mt-16px font-s-14px text-#94a3b8 lt-sm:font-s-22px lt-sm:leading-[34px] m-0 leading-[22px]"
            >
              地址：海南省海口市美兰区西溪里商业街7号楼一楼
            </p>
          </div>

          <div class="w-136px text-center">
            <img
              class="mb-12px h-136px w-136px mx-auto block"
              src="/assets/img/qrcode.svg"
              alt="微信扫码关注我们"
            />
            <span class="pf-sc-regular font-s-16px lt-sm:font-s-24px text-white">
              扫一扫关注我们
            </span>
          </div>
        </div>
      </div>

      <div
        class="pf-sc-regular mt-68px gap-24px font-s-12px text-#64748b lt-sm:mt-40px lt-sm:flex-col lt-sm:gap-8px lt-sm:font-s-20px flex items-center justify-between"
      >
        <a
          class="flex"
          href="#hero"
          aria-label="返回绘管家首页"
          @click="emitNavigate($event, 'hero')"
        >
          <img
            class="h-38px w-147px block object-contain opacity-90 brightness-0 invert"
            src="/assets/img/huiguanjia-logo-web.png"
            alt="绘管家 HUIGUANJIA.CN"
          />
        </a>
        <div class="gap-4px text-#64748b lt-sm:flex-col lt-sm:gap-8px flex flex-wrap items-center">
          <span>Copyright © 2016-2026 海南智慧城科技有限公司</span>
          <a
            class="gap-4px inline-flex items-center transition-colors hover:text-white"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="h-14px w-14px" src="/assets/img/icp.png" alt="" aria-hidden="true" />
            琼ICP备18001846号-3
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  defineOptions({
    name: 'MFooter',
  })

  const { scrollToSection } = useHuiguanjiaHomeContext()

  const emitNavigate = (event: MouseEvent, sectionId: string) => {
    event.preventDefault()
    scrollToSection(sectionId)
  }
</script>
